<script lang="ts" setup>

import { onMounted, reactive } from "vue";
import { useRoute } from "vue-router";

import * as service from "@/services/clientesService";

const route = useRoute();

const controle = reactive({
  carregando: true,
  encontrado: false,
  nome: "",
  ativo: false,
  erro: "",
});

onMounted(() => {
  const id = Number(route.params.id);

  service.validarCartao(id)
    .then(r => {
      controle.encontrado = true;
      controle.nome = r.nome;
      controle.ativo = r.ativo;
    })
    .catch(() => {
      controle.erro = "Cliente não encontrado.";
    })
    .finally(() => {
      controle.carregando = false;
    });
});

</script>

<template>
  <div class="validador-container" :class="{
    'bg-ativo': !controle.carregando && controle.encontrado && controle.ativo,
    'bg-inativo': !controle.carregando && (!controle.encontrado || !controle.ativo)
  }">

    <div v-if="controle.carregando" class="validador-card">
      <div class="spinner-border text-secondary" role="status"></div>
      <div class="mt-3">Verificando...</div>
    </div>

    <div v-else-if="controle.encontrado" class="validador-card">
      <h1 class="validador-titulo">{{ controle.ativo ? 'Cliente Ativo' : 'Cliente Inativo' }}</h1>
      <hr class="validador-linha">
      <div class="validador-nome">{{ controle.nome }}</div>
      <div class="validador-mensagem">
        {{ controle.ativo
          ? 'Cliente está com seu cadastro ativo em nosso sistema.'
          : 'Cliente está com seu cadastro inativo em nosso sistema.' }}
      </div>
    </div>

    <div v-else class="validador-card">
      <h1 class="validador-titulo">Não Encontrado</h1>
      <hr class="validador-linha">
      <div class="validador-mensagem">{{ controle.erro }}</div>
    </div>

  </div>
</template>

<style scoped>
.validador-container {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: #f5f5f5;
}

.bg-ativo {
  background-color: #1e7e4e;
}

.bg-inativo {
  background-color: #b02a2a;
}

.validador-card {
  width: 100%;
  max-width: 720px;
  padding: 32px 24px;
  color: #ffffff;
  text-align: left;
}

.validador-titulo {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 0;
}

.validador-linha {
  border-color: rgba(255, 255, 255, 0.4);
  margin: 16px 0;
}

.validador-nome {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 12px;
}

.validador-mensagem {
  font-size: 15px;
}
</style>
